module.exports = __webpack_public_path__ + "img/sleepingbeauty.64cc7e76.svg";